import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqItems, trustPoints } from "@/mocks/home";

export default function TrustFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 scroll-mt-20">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Trust & FAQ"
          title="这些讨论，是怎么来的"
          description="在参与之前，你可以先了解我们整理热点的原则，以及社区最常被问到的几个问题。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {trustPoints.map((point) => (
            <div
              key={point.title}
              className="rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${point.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {point.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-4 md:p-6">
          <h3 className="font-heading text-lg font-bold text-foreground-950">常见问题</h3>
          <div className="mt-4 divide-y divide-background-200">
            {faqItems.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">
                      {item.q}
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                      <i className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"} />
                    </span>
                  </button>
                  {isOpen ? (
                    <p className="-mt-1 pb-4 pr-8 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}